import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;

	.react-multiple-carousel__arrow--left:before {
		content: '⏴';
		line-height: 0;
	}

	.react-multiple-carousel__arrow--right:before {
		content: '⏵';
		line-height: 0;
	}
`;

export const Cover = styled.img`
	width: 100%;
	height: 520px;
	border-radius: 12px;
	object-fit: cover;

	@media (max-width: ${DESKTOP_BREAKPOINT - 500}px) {
		height: 300px;
	}
`;

export const ThumbsContainer = styled.div`
	padding: 0 8px;

	&:hover {
		opacity: 0.7;
		transition: opacity 0.3s;
	}
`;

export const Thumbnail = styled.img`
	width: 100%;
	height: 120px;
	border-radius: 12px;
	object-fit: cover;
	cursor: pointer;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		height: 80px;
	}
`;
